import React, { useState, useEffect, useCallback, useContext } from "react";
import { Col, Row, Button, Form, Card } from "react-bootstrap";
import Tabs from "../Layout/Tabs";
import { useParams } from "react-router-dom";
import ToastContext from "../Context/ToastContext";
import axios from "axios";
import BillTable from "./Components/BillTable";
import PieChart from "../Charts/PieChart";
import BillTrend from "./Components/BillTrend";
import { format } from "date-fns";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { useAuth } from "../Context/AuthContext";
import logo from "../Assets/Logo.png";
import dhruvaLogo from "../Assets/DhruvaLogo.png"; 

const styles = {
  MainDiv: {
    width: "100vw",
    height: "1100px",
  },
  card: {
    background: "#F9F9F9",
    height: "120px",
    border: "none",
    margin: "",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card1: {
    backgroundColor: "#F9F9F9",
    height: "70px",
    border: "none",
    margin: "20px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 50px",
  },
  dropdownCard: {
    backgroundColor: "#FFF",
    height: "70px",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },

  card3: {
    backgroundColor: "#F9F9F9",
    height: "420px",
    border: "none",
    margin: "20px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const pageHeadFormat = (pdf, label, logoBase64) => {
  pdf.autoTable({
    styles: {
      fillColor: [255, 255, 255],
      fontStyle: "bold",
      textColor: [11, 39, 51],
      fontSize: 14,
    },
    columnStyles: {
      0: {
        valign: "middle",
        halign: "center",
        minCellHeight: 15,
        cellWidth: 47,
        fillColor: [255, 255, 255],
      },
      1: {
        valign: "middle",
        halign: "center",
        cellWidth: 174,
        fillColor: [255, 255, 255],
        fontSize: 18,
        textColor: "#375EAD",
      },
      2: {
        valign: "middle",
        halign: "center",
        cellWidth: 40,
        fillColor: [255, 255, 255],
      },
    }, // Cells in first column centered and green
    margin: { top: 10, right: 10 },
    body: [[" ", label, " "]],
    didDrawCell: function (data) {
      if (data.column.index === 2 && data.cell.section === "body") {
        // pdf.addImage(
        //   "https://netpositive.cloud/static/media/Netp_Logo_2.10.2170837edb899c1edf35.png",
        pdf.addImage(
          logoBase64,
          "PNG",
          data.cell.x + 1,
          data.cell.y + 1,
          45,
          13
        );
      }
      if (data.column.index === 0 && data.cell.section === "body") {
        pdf.addImage(
          "data:image/png;base64,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",
          data.cell.x + 1,
          data.cell.y + 1,
          45,
          13
        );
      }
    },
  });
};

// const pageFooterFormat = async (pdf, data) => {
//   let timeStamp = `Printed on : ${format(new Date(), "dd-MM-yyyy HH:mm:ss")}`;
//   pdf.setFontSize(10);
//   pdf.setFont("Helvetica", "bold");
//   // jsPDF 1.4+ uses getWidth, <1.4 uses .width
//   var pageSize = pdf.internal.pageSize;
//   var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
//   var pageWidth = pageSize.Width ? pageSize.width : pageSize.getWidth();
//   pdf.setTextColor(40);
//   pdf.text(timeStamp, data.settings.margin.left, pageHeight - 5);
//   pdf.text("Developed by", pageWidth - 67, pageHeight - 5);
//   pdf.addImage(
//     "https://netpositive.cloud/static/media/DhruvaLogo.16130d94852520aabe54.png",
//     pageWidth - 45,
//     pageHeight - 15,
//     35,
//     14
//   );
// };
const pageFooterFormat = async (pdf, data,dhruvaLogoBase64) => {
  let timeStamp = `Printed on : ${format(new Date(), "dd-MM-yyyy HH:mm:ss")}`;
  pdf.setFontSize(10);
  pdf.setFont("Helvetica", "bold");
  var pageSize = pdf.internal.pageSize;
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
  var pageWidth = pageSize.Width ? pageSize.width : pageSize.getWidth();
  pdf.setTextColor(40);
  pdf.text(timeStamp, data.settings.margin.left, pageHeight - 5);
  pdf.text("Developed by", pageWidth - 67, pageHeight - 5);
   pdf.addImage(dhruvaLogoBase64, "PNG", pageWidth - 45, pageHeight - 15, 35, 14);

  // Fetch Dhruva logo as base64
  try {
    const response = await fetch(
      "https://netpositive.cloud/static/media/DhruvaLogo.16130d94852520aabe54.png"
    );
    const blob = await response.blob();
    const base64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
    pdf.addImage(base64, "PNG", pageWidth - 45, pageHeight - 15, 35, 14);
  } catch (e) {
    console.error("Dhruva logo failed to load", e);
  }
};

const addPageNumber = (pdf) => {
  // Footer
  pdf.setFontSize(10);
  pdf.setFont("Helvetica", "bold");
  let middle = pdf.internal.pageSize.getWidth() / 2 - 5;
  // jsPDF 1.4+ uses getWidth, <1.4 uses .width
  var pageSize = pdf.internal.pageSize;
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
  pdf.setTextColor(40);
  var totalPages = pdf.internal.getNumberOfPages();
  for (var i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.text("Page No. " + i + "/" + totalPages, middle, pageHeight - 5);
  }
};

const ShopWiseBilling = () => {
  const { toast } = useContext(ToastContext);
  const { token } = useAuth();
  const { shopname } = useParams();
  const [pieChartDetails, setPieChartDetails] = useState({
    chartData: { labels: ["Drinking Total", "Process Total"], datasets: [] },
    chartOptions: {},
  });
  const [lineChartDetails, setLineChartDetails] = useState({
    lineGraphData: { labels: [], datasets: [] },
  });
  const [consumptionData, setConsumptionData] = useState([]);
  const [overallConsumption, setOverallConsumption] = useState([]);
  const [totalConsumption, setTotalConsumption] = useState(0);

  const URL = process.env.REACT_APP_URL;
  const [yearMonthFilter, setYearMonthFilter] = useState({
    year: "",
    month: "",
  });

  const handleSelectYear = (event) => {
    setYearMonthFilter({ ...yearMonthFilter, year: event.target.value });
  };

  const handleSelectMonth = (event) => {
    setYearMonthFilter({ ...yearMonthFilter, month: event.target.value });
  };

  const fetchDaywiseConsumptionData = useCallback(async () => {
    let url = `${URL}get-bill/${shopname}/${yearMonthFilter.year}/${yearMonthFilter.month}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `abc ${token}`,
        },
      });

      setConsumptionData(response?.data?.data);
      //toast.success("Other Consumption Data Updated");
    } catch (err) {

    }
  }, [yearMonthFilter]);

  const fetchTotalConsumptionData = useCallback(async () => {
    let url = `${URL}get-consumption-details/${shopname}/${yearMonthFilter.year}/${yearMonthFilter.month}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `abc ${token}`,
        },
      });

      setOverallConsumption(response?.data?.data);
      //setTotalConsumption(response?.data?.data[0].Total);
      //toast.success("Other Consumption Data Updated");
    } catch (err) {

    }
  }, [yearMonthFilter]);

  useEffect(() => {
    fetchDaywiseConsumptionData();
    fetchTotalConsumptionData();
    console.log(consumptionData);
  }, []);

  useEffect(() => {
    fetchDaywiseConsumptionData();
    fetchTotalConsumptionData();
  }, [fetchDaywiseConsumptionData]);

  const handleChartDataChange = useCallback(() => {
    let processTotal = 0;
    let drinkingTotal = 0;
    let tempChartData = {};
    let datesArray = [];
    let drinkingTotalArray = [];
    let processTotalArray = [];
    let lineChartData = {};
    let total = 0;
    switch (shopname) {
      case "Press Shop":
        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Press_Shop_Drinking_Total
            : consumptionData.reduce((sum, item) => {
              if (item.Press_Shop_Drinking !== null) {
                return sum + (item.Press_Shop_Drinking || 0);
              }
              return sum;
            }, 0);
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Press_Shop_Process_Total
            : consumptionData.reduce((sum, item) => {
              if (item.Press_Shop_Process !== null) {
                return sum + (item.Press_Shop_Process || 0);
              }
              return sum;
            }, 0);
        console.log("PPT,PDT", processTotal, drinkingTotal);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map(
          (entry) => entry.Press_Shop_Drinking
        );
        processTotalArray = consumptionData.map(
          (entry) => entry.Press_Shop_Process
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Nexon BIW":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              if (item.A_Grid_Process !== null) {
                return sum + (item.A_Grid_Process || 0);
              }
              return sum;
            }, 0);

        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              if (item.Weld_Shop_Drinking !== null) {
                return sum + (item.Weld_Shop_Drinking || 0);
              }
              return sum;
            }, 0);
        console.log("PPT,PDT", processTotal, drinkingTotal);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map(
          (entry) => entry.Weld_Shop_Drinking
        );
        processTotalArray = consumptionData.map(
          (entry) => entry.A_Grid_Process
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Paint Shop":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item?.Process_Total || 0) > 0
                    ? Number(item.Process_Total || 0)
                    : 0)
                );
              }
            }, 0);

        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item?.Drinking_Total || 0) > 0
                    ? Number(item.Drinking_Total || 0)
                    : 0)
                );
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Drinking_Total || 0) > 0
            ? Number(entry.Drinking_Total)
            : 0
        );
        processTotalArray = consumptionData.map((entry) =>
          Number(entry?.Process_Total || 0) > 0
            ? Number(entry.Process_Total)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "TCF1":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item?.Process_Total || 0) > 0
                    ? Number(item.Process_Total || 0)
                    : 0)
                );
              }
            }, 0);

        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Drinking_Total || 0) > 0
                    ? Number(item.Drinking_Total || 0)
                    : 0)
                );
              }
            }, 0);

        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Drinking_Total || 0) > 0
            ? Number(entry.Drinking_Total)
            : 0
        );
        processTotalArray = consumptionData.map((entry) =>
          Number(entry?.Process_Total || 0) > 0
            ? Number(entry.Process_Total)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "TCF2":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item?.TCF_2_Process || 0) > 0
                    ? Number(item.TCF_2_Process || 0)
                    : 0)
                );
              }
            }, 0);

        //drinkingTotal = 0;

        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.TCF_2_Drinking || 0) > 0
                    ? Number(item.TCF_2_Drinking || 0)
                    : 0)
                );
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.TCF_2_Drinking || 0) > 0
            ? Number(entry.TCF_2_Drinking)
            : 0
        );
        processTotalArray = consumptionData.map((entry) =>
          Number(entry?.TCF_2_Process || 0) > 0
            ? Number(entry.TCF_2_Process)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });

        break;
      case "Powertrain":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              {
                return sum + item.Total_Process;
              }
            }, 0);

        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              {
                return sum + item.Total_Drinking;
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Total_Drinking || 0)
            ? Number(entry.Total_Drinking)
            : 0
        );
        processTotalArray = consumptionData.map((entry) =>
          Number(entry?.Total_Process || 0)
            ? Number(entry.Total_Process)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Canteen1":
        processTotal = 0;

        drinkingTotal = consumptionData.reduce((sum, item) => {
          {
            return (
              sum +
              (Number(item.Canteen1_Drinking || 0) > 0
                ? Number(item.Canteen1_Drinking)
                : 0)
            );
          }
        }, 0);

        setTotalConsumption(processTotal + drinkingTotal);
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Canteen1_Drinking || 0) > 0
            ? Number(entry.Canteen1_Drinking)
            : 0
        );
        processTotalArray = consumptionData.map((entry) => 0);
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Canteen2":
        processTotal = 0;

        drinkingTotal = consumptionData.reduce((sum, item) => {
          {
            return (
              sum +
              (Number(item.Canteen2_Drinking || 0) > 0
                ? Number(item.Canteen2_Drinking)
                : 0)
            );
          }
        }, 0);

        setTotalConsumption(processTotal + drinkingTotal);
        tempChartData = {
          labels: ["Drinking Total", "Process Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Canteen1_Drinking || 0) > 0
            ? Number(entry.Canteen1_Drinking)
            : 0
        );
        processTotalArray = consumptionData.map((entry) => 0);
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Car Plant":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.RO_Transfer || 0) > 0
                    ? Number(item.RO_Transfer)
                    : 0)
                );
              }
            }, 0);

        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Fresh_Water || 0) > 0
                    ? Number(item.Total_Fresh_Water)
                    : 0)
                );
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Fresh Water Total", "Recycled Water Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Total_Fresh_Water || 0) > 0
            ? Number(entry.Total_Fresh_Water)
            : 0
        );
        processTotalArray = consumptionData.map((entry) =>
          Number(entry.RO_Transfer || 0) > 0 ? Number(entry.RO_Transfer) : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Fresh Water Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Reacycled Water Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "ETP":
        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.RO_Transfer || 0) > 0
                    ? Number(item.RO_Transfer)
                    : 0)
                );
              }
            }, 0);

        drinkingTotal = 0;

        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;

        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Fresh Water Total", "Recycled Water Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        drinkingTotalArray = [];
        processTotalArray = consumptionData.map((entry) =>
          Number(entry.RO_Transfer || 0) > 0 ? Number(entry.RO_Transfer) : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Fresh Water Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Reacycled Water Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "JLR":
        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.JLR_Block_Drinking || 0) > 0
                    ? Number(item.JLR_Block_Drinking)
                    : 0)
                );
              }
            }, 0);

        processTotal = 0;
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Fresh Water Total", "Process Water Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        processTotalArray = [];
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.JLR_Block_Drinking || 0) > 0
            ? Number(entry.JLR_Block_Drinking)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Water Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Water Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Canteen K Block":
        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Drinking || 0) > 0
                    ? Number(item.Total_Drinking)
                    : 0)
                );
              }
            }, 0);

        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total_Process
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Process || 0) > 0
                    ? Number(item.Total_Process)
                    : 0)
                );
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(overallConsumption[0]?.Total));
        tempChartData = {
          labels: ["Fresh Water Total", "Process Water Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });

        processTotalArray = consumptionData.map((entry) =>
          Number(entry.Total_Process || 0) > 0 ? Number(entry.Total_Process) : 0
        );
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Total_Drinking || 0) > 0
            ? Number(entry.Total_Drinking)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Water Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Water Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      case "Compressor House":
        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total || 0
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Drinking || 0) > 0
                    ? Number(item.Total_Drinking)
                    : 0)
                );
              }
            }, 0);

        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Process_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Process || 0) > 0
                    ? Number(item.Total_Process)
                    : 0)
                );
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Fresh Water Total", "Process Water Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        // processTotalArray = [];

        processTotalArray = consumptionData.map((entry) =>
          Number(entry.Total_Process || 0) > 0 ? Number(entry.Total_Process) : 0
        );
        drinkingTotalArray = [];
        // drinkingTotalArray = consumptionData.map((entry) =>
        //   Number(entry.Total_Drinking || 0) > 0
        //     ? Number(entry.Total_Drinking)
        //     : 0
        // );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Water Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Water Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
      default:
        drinkingTotal =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Drinking_Total
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Drinking || 0) > 0
                    ? Number(item.Total_Drinking)
                    : 0)
                );
              }
            }, 0);

        processTotal =
          overallConsumption && overallConsumption?.length > 0
            ? isNaN(overallConsumption[0]?.Total_Process)
              ? 0
              : overallConsumption[0]?.Total_Process
            : consumptionData.reduce((sum, item) => {
              {
                return (
                  sum +
                  (Number(item.Total_Process || 0) > 0
                    ? Number(item.Total_Process)
                    : 0)
                );
              }
            }, 0);
        total =
          overallConsumption && overallConsumption?.length > 0
            ? overallConsumption[0]?.Total
            : processTotal + drinkingTotal;
        setTotalConsumption(Math.round(total));
        tempChartData = {
          labels: ["Fresh Water Total", "Process Water Total"],
          datasets: [
            {
              label: "",
              data: [
                Number(drinkingTotal).toFixed(2),
                Number(processTotal).toFixed(2),
              ],
              backgroundColor: ["#C30000", "#1e5094"],
              borderColor: ["white"],
              borderWidth: 2,
            },
          ],
        };
        setPieChartDetails({
          ...pieChartDetails,
          chartData: tempChartData,
        });

        datesArray = consumptionData.map((entry) => {
          const dateObj = new Date(entry?.D);
          return format(dateObj, "dd/MM");
        });
        processTotalArray = [];

        // processTotalArray = consumptionData.map((entry) =>
        //   Number(entry.Total_Process || 0) > 0 ? Number(entry.Total_Process) : 0
        // );
        drinkingTotalArray = consumptionData.map((entry) =>
          Number(entry.Total_Drinking || 0) > 0
            ? Number(entry.Total_Drinking)
            : 0
        );
        lineChartData = {
          labels: datesArray,
          datasets: [
            {
              label: "Drinking Water Total",
              data: drinkingTotalArray,
              borderColor: "#C30000",
              backgroundColor: "#C30000",
              yAxisID: "y1", // Use the left y-axis
            },
            {
              label: "Process Water Total",
              data: processTotalArray,
              borderColor: "#1e5094",
              backgroundColor: "#1e5094",
              yAxisID: "y", // Use the left y-axis
            },
          ],
        };
        setLineChartDetails({
          ...lineChartDetails,
          lineGraphData: lineChartData,
        });
        break;
    }
  }, [consumptionData, yearMonthFilter, overallConsumption]);

  useEffect(() => {
    handleChartDataChange();
  }, [handleChartDataChange]);

  useEffect(() => {
    let currentDate = new Date();
    let currentMonth = currentDate.getMonth() + 1;
    let currentYear = currentDate.getFullYear();
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let currentMonthName = monthNames[currentMonth - 1]; // Subtracting 1 to adjust for 0-indexing
    console.log("currentMonth , Current Year", currentMonthName, currentYear);
    setYearMonthFilter({
      ...yearMonthFilter,
      year: currentYear,
      month: currentMonthName,
    });
  }, []);

  // const handleCSVDownload = () => {
  //   const { year, month } = yearMonthFilter;
  //   if (shopname === "Press Shop") {
  //     if (consumptionData?.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Press_Shop_Process: entry.Press_Shop_Process?.toFixed(2) || "--",
  //         Press_Shop_Drinking: entry.Press_Shop_Drinking?.toFixed(2) || "--",
  //         Total: entry.Total?.toFixed(2),
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption ${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Nexon BIW") {
  //     if (consumptionData?.length > 0) {
  //       const csvData = consumptionData.map((entry) => ({
  //         Sr_No: entry.id,
  //         Date: entry.D,
  //         Weld_Shop_A_Grid_Process_Water:
  //           entry.A_Grid_Process?.toFixed(2) || "--",
  //         Weld_Shop_Drinking_Water:
  //           entry.Weld_Shop_Drinking?.toFixed(2) || "--",
  //         Total: entry.Total?.toFixed(2),
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL ${shopname} Water Consumption ${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else toast.error("No data available for download");
  //   } else if (shopname === "Paint Shop") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Canteen1_Drinking:
  //           entry.Canteen1_Drinking?.toFixed(2) > 0
  //             ? entry.Canteen1_Drinking?.toFixed(2)
  //             : 0,
  //         Canteen2_Drinking:
  //           entry.Canteen2_Drinking?.toFixed(2) > 0
  //             ? entry.Canteen2_Drinking?.toFixed(2)
  //             : 0,
  //         Paint_Shop_Drinking_Total:
  //           entry.Paint_Shop_Drinking?.toFixed(2) > 0
  //             ? entry.Paint_Shop_Drinking?.toFixed(2)
  //             : 0,
  //         L_Grid_Process:
  //           entry.L_Grid_Process?.toFixed(2) > 0
  //             ? entry.L_Grid_Process?.toFixed(2)
  //             : 0,
  //         K_Grid_Process:
  //           entry.K_Grid_Process?.toFixed(2) > 0
  //             ? entry.K_Grid_Process?.toFixed(2)
  //             : 0,
  //         O_Grid_Process:
  //           entry.O_Grid_Process?.toFixed(2) > 0
  //             ? entry.O_Grid_Process?.toFixed(2)
  //             : 0,
  //         Process_Total:
  //           entry.Process_Total?.toFixed(2) > 0
  //             ? entry.Process_Total?.toFixed(2)
  //             : 0,
  //         Total: entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "TCF1") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         TCF_1_Drinking: getValidatedValue(entry.TCF_1_Drinking),
  //         TCF_2_Drinking: getValidatedValue(entry.TCF_2_Drinking),
  //         Drinking_Total:
  //           entry.Drinking_Total?.toFixed(2) > 0
  //             ? entry.Drinking_Total?.toFixed(2)
  //             : 0,
  //         Process_1: getValidatedValue(entry.Process_1),
  //         Process_2: getValidatedValue(entry.Process_2),
  //         Process_3: getValidatedValue(entry.Process_3),
  //         Process_Total:
  //           entry.Process_Total?.toFixed(2) > 0
  //             ? entry.Process_Total?.toFixed(2)
  //             : 0,
  //         Total: entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "TCF2") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         TCF_2_Drinking: getValidatedValue(entry.TCF_2_Drinking),
  //         TCF_2_Process: getValidatedValue(entry.TCF_2_Process),
  //         Total: entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Powertrain") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Engine_Shop_Drinking: getValidatedValue(entry.Engine_Shop_Drinking),
  //         Omega_PDI_Drinking: getValidatedValue(entry.Omega_PDI_Drinking),
  //         Parking_Area_Drinking: getValidatedValue(entry.Parking_Area_Drinking),
  //         Scarpyard_Drinking: getValidatedValue(entry.Scarpyard_Drinking),
  //         Total_Drinking: getValidatedValue(entry.Total_Drinking),
  //         Main_Engine_Line: getValidatedValue(entry.Main_Engine_Line),
  //         PDI_Solar_1_Process: getValidatedValue(entry.PDI_Solar_1_Process),
  //         PDI_Solar_2_Process: getValidatedValue(entry.PDI_Solar_2_Process),
  //         Total_Process: getValidatedValue(entry.Total_Process),
  //         Total: entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Canteen1") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Canteen1_Drinking:
  //           entry.Canteen1_Drinking?.toFixed(2) > 0
  //             ? entry.Canteen1_Drinking?.toFixed(2)
  //             : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Car Plant") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         MIDC_Fresh_Water_1:
  //           entry.MIDC_Fresh_Water_1?.toFixed(2) > 0
  //             ? entry.MIDC_Fresh_Water_1?.toFixed(2)
  //             : 0,
  //         MIDC_Fresh_Water_2:
  //           entry.MIDC_Fresh_Water_2?.toFixed(2) > 0
  //             ? entry.MIDC_Fresh_Water_2?.toFixed(2)
  //             : 0,
  //         Total_Fresh_Water:
  //           entry.Total_Fresh_Water?.toFixed(2) > 0
  //             ? entry.Total_Fresh_Water?.toFixed(2)
  //             : 0,
  //         RO_Transfer:
  //           entry.RO_Transfer?.toFixed(2) > 0
  //             ? entry.RO_Transfer?.toFixed(2)
  //             : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Canteen2") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Canteen2_Drinking:
  //           entry.Canteen2_Drinking?.toFixed(2) > 0
  //             ? entry.Canteen2_Drinking?.toFixed(2)
  //             : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL Canteen 2 Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "ETP") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         RO_Transfer:
  //           entry.RO_Transfer?.toFixed(2) > 0
  //             ? entry.RO_Transfer?.toFixed(2)
  //             : 0,
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(csvBlob, `TMPVL ETP Water Consumption${year}_${month}.csv`);
  //       toast.success(" Data downloading, please wait...");
  //     }
  //   } else if (shopname === "JLR") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         JLR_Block_Drinking: getValidatedValue(entry.JLR_Block_Drinking),
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     }
  //   } else if (shopname === "Canteen K Block") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Office_Block_Drinking: getValidatedValue(
  //           entry.Office_Tank_Fill_Drinking
  //         ),
  //         ERC_Service_Block_Drinking: getValidatedValue(
  //           entry.ARC_Service_Block_Drinking
  //         ),
  //         OB_Canteen_Mori_Drinking: getValidatedValue(
  //           entry.Office_Service_Block_Drinking
  //         ),
  //         Engine_Shop_Drinking: getValidatedValue(entry.Engine_Shop_Drinking),
  //         Total: getValidatedValue(entry.Total),
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     }
  //   } else if (shopname === "Compressor House") {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Compressor_Room: getValidatedValue(entry.Compressor_Room),
  //         Compressor_House: getValidatedValue(entry.Compressor_House),
  //         Total: getValidatedValue(entry.Total),
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else {
  //     if (consumptionData.length > 0) {
  //       const csvData = consumptionData.map((entry, index) => ({
  //         Sr_No: index + 1,
  //         Date: entry.D,
  //         Total: getValidatedValue(entry.Total),
  //       }));

  //       const csvBlob = new Blob([Papa.unparse(csvData, { quotes: true })], {
  //         type: "text/csv;charset=utf-8;",
  //       });

  //       saveAs(
  //         csvBlob,
  //         `TMPVL  ${shopname} Water Consumption${year}_${month}.csv`
  //       );
  //       toast.success(" Data downloading, please wait...");
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   }
  // };

  const handleCSVDownload = () => {
    const { year, month } = yearMonthFilter;
    const table = document.getElementById("reportTable");
    const wb = XLSX.utils.table_to_book(table, {
      sheet: `${shopname}`,
    });
    XLSX.writeFile(
      wb,
      `TMPVL ${shopname} Water Consumption ${year}-${month}.xlsx`
    );
  };

  // const handlePdfDownload = async () => {
  //   const { year, month } = yearMonthFilter;
  //   if (shopname === "Press Shop") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "Press Shop Process Water",
  //         "Press Shop Drinking Water",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((obj, index) => [
  //         index + 1,
  //         obj.D,
  //         obj.Press_Shop_Process?.toFixed(2) || "--",
  //         obj.Press_Shop_Drinking?.toFixed(2) || "--",
  //         obj.Total?.toFixed(2),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Nexon BIW") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "Weld Shop 'A' Grid Process Water",
  //         "Weld Shop Drinking Water",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((obj, index) => [
  //         index + 1,
  //         obj.D,
  //         obj.A_Grid_Process?.toFixed(2) || "--",
  //         obj.Weld_Shop_Drinking?.toFixed(2) || "--",
  //         obj.Total?.toFixed(2),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Paint Shop") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "Canteen1 Drinking",
  //         "Canteen2 Drinking",
  //         "Paint Shop Drinking Total",
  //         "L Grid Process",
  //         "K Grid Process",
  //         "O Grid Process",
  //         "Process Total",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         entry.Canteen1_Drinking?.toFixed(2) > 0
  //           ? entry.Canteen1_Drinking?.toFixed(2)
  //           : 0,
  //         entry.Canteen2_Drinking?.toFixed(2) > 0
  //           ? entry.Canteen2_Drinking?.toFixed(2)
  //           : 0,
  //         entry.Paint_Shop_Drinking?.toFixed(2) > 0
  //           ? entry.Paint_Shop_Drinking?.toFixed(2)
  //           : 0,
  //         entry.L_Grid_Process?.toFixed(2) > 0
  //           ? entry.L_Grid_Process?.toFixed(2)
  //           : 0,
  //         entry.K_Grid_Process?.toFixed(2) > 0
  //           ? entry.K_Grid_Process?.toFixed(2)
  //           : 0,
  //         entry.O_Grid_Process?.toFixed(2) > 0
  //           ? entry.O_Grid_Process?.toFixed(2)
  //           : 0,
  //         entry.Process_Total?.toFixed(2) > 0
  //           ? entry.Process_Total?.toFixed(2)
  //           : 0,
  //         entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "TCF1") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "TCF 1 Drinking",
  //         "TCF 2 Drinking",
  //         "Drinking Total",
  //         "Process 1",
  //         "Process 2",
  //         "Process 3",
  //         "Process Total",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.TCF_1_Drinking),
  //         getValidatedValue(entry.TCF_2_Drinking),
  //         getValidatedValue(entry.Drinking_Total),
  //         getValidatedValue(entry.Process_1),
  //         getValidatedValue(entry.Process_2),
  //         getValidatedValue(entry.Process_3),
  //         entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "TCF2") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "TCF 2 Drinking",
  //         "TCF 2 Process",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.TCF_2_Drinking),
  //         getValidatedValue(entry.TCF_2_Process),
  //         getValidatedValue(entry.Total),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Powertrain") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "Engine Shop Drinking",
  //         "Omega PDI Drinking",
  //         "Parking Area Drinking",
  //         "Scarpyard Drinking",
  //         "Total Drinking",
  //         "Main Engine Line",
  //         "PDI Solar 1 Process",
  //         "PDI Solar 2 Process",
  //         "Total Process",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.Engine_Shop_Drinking),
  //         getValidatedValue(entry.Omega_PDI_Drinking),
  //         getValidatedValue(entry.Parking_Area_Drinking),
  //         getValidatedValue(entry.Scarpyard_Drinking),
  //         getValidatedValue(entry.Total_Drinking),
  //         getValidatedValue(entry.Main_Engine_Line),
  //         getValidatedValue(entry.PDI_Solar_1_Process),
  //         getValidatedValue(entry.PDI_Solar_2_Process),
  //         entry.Total_Process?.toFixed(2) > 0
  //           ? entry.Total_Process?.toFixed(2)
  //           : 0,
  //         entry.Total?.toFixed(2) > 0 ? entry.Total?.toFixed(2) : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Canteen1") {
  //     if (consumptionData?.length > 0) {
  //       const columns = ["Sr.no", "Date", "Canteen1 Drinking"];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         entry.Canteen1_Drinking?.toFixed(2) > 0
  //           ? entry.Canteen1_Drinking?.toFixed(2)
  //           : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Canteen2") {
  //     if (consumptionData?.length > 0) {
  //       const columns = ["Sr.no", "Date", "Canteen2 Drinking"];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         entry.Canteen2_Drinking?.toFixed(2) > 0
  //           ? entry.Canteen2_Drinking?.toFixed(2)
  //           : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "ETP") {
  //     if (consumptionData?.length > 0) {
  //       const columns = ["Sr.no", "Date", "RO Transfer"];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         entry.RO_Transfer?.toFixed(2) > 0 ? entry.RO_Transfer?.toFixed(2) : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Car Plant") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "MIDC Fresh Water 1",
  //         "MIDC Fresh Water 2",
  //         "Total Fresh Water",
  //         "RO Transfer",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         entry.MIDC_Fresh_Water_1?.toFixed(2) > 0
  //           ? entry.MIDC_Fresh_Water_1?.toFixed(2)
  //           : 0,
  //         entry.MIDC_Fresh_Water_2?.toFixed(2) > 0
  //           ? entry.MIDC_Fresh_Water_2?.toFixed(2)
  //           : 0,
  //         entry.Total_Fresh_Water?.toFixed(2) > 0
  //           ? entry.Total_Fresh_Water?.toFixed(2)
  //           : 0,
  //         Number(entry.RO_Transfer?.toFixed(2) || 0) > 0
  //           ? entry.RO_Transfer?.toFixed(2)
  //           : 0,
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "JLR") {
  //     if (consumptionData?.length > 0) {
  //       const columns = ["Sr.no", "Date", "JLR Block Drinking"];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.JLR_Block_Drinking),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Canteen K Block") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "Office Block Drinking",
  //         "ERC Service Block Drinking",
  //         "OB Canteen Mori Drinking",
  //         "Engine Shop Drinking",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.Office_Tank_Fill_Drinking),
  //         getValidatedValue(entry.ARC_Service_Block_Drinking),
  //         getValidatedValue(entry.Office_Service_Block_Drinking),
  //         getValidatedValue(entry.Engine_Shop_Drinking),
  //         getValidatedValue(entry.Total),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else if (shopname === "Compressor House") {
  //     if (consumptionData?.length > 0) {
  //       const columns = [
  //         "Sr.no",
  //         "Date",
  //         "Compressor Room",
  //         "Compressor House",
  //         "Total",
  //       ];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.Compressor_Room),
  //         getValidatedValue(entry.Compressor_House),
  //         getValidatedValue(entry.Total),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   } else {
  //     if (consumptionData?.length > 0) {
  //       const columns = ["Sr.no", "Date", "Total"];
  //       const rows = consumptionData.map((entry, index) => [
  //         index + 1,
  //         entry.D,
  //         getValidatedValue(entry.Total),
  //       ]);
  //       await generatePdf(columns, rows, year, month, shopname);
  //     } else {
  //       toast.error("No data available for download");
  //     }
  //   }
  // };
  const handleSearch = useCallback(async () => {
  let url1 = `${URL}get-bill/${shopname}/${yearMonthFilter.year}/${yearMonthFilter.month}`;
  let url2 = `${URL}get-consumption-details/${shopname}/${yearMonthFilter.year}/${yearMonthFilter.month}`;
  
  try {
    const [res1, res2] = await Promise.all([
      axios.get(url1, { headers: { Authorization: `abc ${token}` } }),
      axios.get(url2, { headers: { Authorization: `abc ${token}` } }),
    ]);
    setConsumptionData(res1?.data?.data);
    setOverallConsumption(res2?.data?.data);
  } catch (err) {
    console.error(err);
  }
}, [yearMonthFilter, shopname, token, URL]);

  const DataDownload = async () => {
    const { year, month } = yearMonthFilter;
    handleCSVDownload();
    await generatePdf(year, month, shopname);
  };

  return (
    <div style={{ width: "100%" }}>
      {" "}
      <Tabs />
      <div style={{ margin: 10 }}>
        <Row id="header">
          <Col xs={12} md={12}>
            <div className="card" style={styles.card1}>
              <img
                src={require("../Assets/drop.png")}
                width="50"
                height="50"
                alt="logo"
              />
              <h3>{`${shopname} Bill`}</h3>
              <img
                src={require("../Assets/bar-chart.png")}
                width="50"
                height="50"
                alt="logo"
              />
            </div>
          </Col>
        </Row>

        <Row style={{ margin: "3%" }}>
          <Col xs={1} md={2} style={{ textAlign: "center" }}>
            Select Year :
          </Col>
          <Col xs={1} md={2}>
            <Form>
              {/* <Form.Select
                value={yearMonthFilter.year}
                onChange={handleSelectYear}
              >
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </Form.Select> */}
              <Form.Select
                value={yearMonthFilter.year}
                onChange={handleSelectYear}
              >
                {Array.from(
                  { length: new Date().getFullYear() - 2022 + 1 },
                  (_, i) => 2022 + i
                ).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Form.Select>
            </Form>
          </Col>
          <Col xs={1} md={2} style={{ textAlign: "center" }}>
            Select Month :
          </Col>
          <Col xs={1} md={2}>
            <Form>
              <Form.Select
                value={yearMonthFilter.month}
                onChange={handleSelectMonth}
              >
                {Array.from({ length: 12 }, (_, index) => {
                  const monthNumber = ((index + 3) % 12) + 1;
                  const monthLabel = new Date(
                    2022,
                    monthNumber - 1,
                    1
                  ).toLocaleString("en-US", { month: "short" });
                  return (
                    <option key={monthNumber} value={monthLabel}>
                      {monthLabel}
                    </option>
                  );
                })}
              </Form.Select>
            </Form>
          </Col>

          <Col
  xs={1}
  md={4}
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  }}
>
  <Button
  onClick={handleSearch}
  style={{ backgroundColor: "navy", border: "none" }}
>
  Search
</Button>
  <Button
    onClick={DataDownload}
    style={{ backgroundColor: "navy", border: "none" }}
  >
    Download
  </Button>
</Col>
        </Row>
        {consumptionData.length > 0 && (
          <Card
            id="graphs"
            style={{
              margin: "15px",
              border: "none",
            }}
          >
            <Row style={{ marginLeft: 10 }}>
              <Col
                md={5}
                style={{
                  backgroundColor: "#f8f8f8",
                  borderRadius: 10,
                  paddingLeft: 60,
                  marginRight: 30,
                }}
              >
                <div style={{ height: 450, width: 450 }}>
                  <PieChart
                    data={pieChartDetails?.chartData}
                    width={250}
                    height={250}
                  />
                </div>
              </Col>
              <Col
                md={6}
                style={{
                  backgroundColor: "#f8f8f8",
                  paddingTop: 40,
                  marginLeft: "4%",
                  paddingLeft: "3%",
                }}
              >
                <div style={{ display: "flex" }}>
                  <BillTrend trendData={lineChartDetails?.lineGraphData} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12} style={{ padding: "20px" }}>
                <div className="card" style={styles.card}>
                  <h2 style={{ color: "#C30000", fontWeight: "bold" }}>
                    {totalConsumption} KL
                  </h2>
                  <h5>
                    {shopname !== "ETP"
                      ? `TOTAL WATER CONSUMPTION (${yearMonthFilter.month} ${yearMonthFilter.year})`
                      : `TOTAL RECYCLED WATER (${yearMonthFilter.month} ${yearMonthFilter.year})`}
                  </h5>
                </div>
              </Col>
            </Row>
          </Card>
        )}

        {consumptionData.length > 0 && (
          <div
            style={{
              overflowX: "auto",
              padding: "0px 15px",
              marginTop: "1%",
            }}
          >
            {" "}
            <BillTable data={consumptionData} shopname={shopname} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopWiseBilling;


async function generatePdf(year, month, shopname) {
  const doc = new jsPDF("landscape");
  pageHeadFormat(doc, `${shopname} Bill`, logo);
  //   const logoBase64 = await getBase64ImageFromURL(
  //   "https://netpositive.cloud/static/media/Netp_Logo_2.10.2170837edb899c1edf35.png"
  // );

  
  const chart = document.getElementById("graphs");

  const canvas = await html2canvas(chart);
  const imgData = canvas.toDataURL("image/jpeg");
  doc.addImage(
    imgData,
    "JPEG",
    12,
    35,
    doc.internal.pageSize.getWidth() - 24,
    110
  );

  doc.autoTable({
    margin: { top: 10 },
    startY: 145,
    html: "#reportTable",
    theme: "grid",
    styles: {
      valign: "middle",
      halign: "center",
      cellPadding:
        shopname === "Powertrain"
          ? { top: 5, bottom: 5, left: 3, right: 3 }
          : 5,
      lineColor: "#C9C9C9",
    },
    headStyles: {
      lineColor: "#C9C9C9",
      lineWidth: 0.1,
    },
    didDrawPage: function (data) {
      pageFooterFormat(doc, data , dhruvaLogo);
    },
  });
  addPageNumber(doc);
  doc.save(`TMPVL ${shopname} Water Consumption ${year}_${month}.pdf`);
}
